import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/integrations/$')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => search,
})

function RouteComponent() {
  const { _splat } = Route.useParams()
  const search = Route.useSearch()
  const path = _splat ? `/${_splat}` : ''
  const query = Object.keys(search).length
    ? `?${new URLSearchParams(search as Record<string, string>).toString()}`
    : ''
  return (
    <iframe
      title="Integrations"
      style={{ height: '100%', border: 'none' }}
      src={`/ll/embedded.html#integrations${path}${query}`}
    />
  )
}
